const remote ="https://e-grade-server.herokuapp.com";
const local = "http://localhost:3020";
const api = {
  remoteUrl:remote,
  localUrl:remote,
}
export default api;